import debounce from 'debounce';
import React, { useCallback, useState } from 'react';

import { Icon, IconClose, IconMagnifier } from '@flixbus/honeycomb-icons-react';
import { Button, Input } from '@flixbus/honeycomb-react';

import styles from './styles.module.css';

const CrewMemberTextSearch = ({
	fieldControl,
	submitOnChange,
	onReset,
	isDirty,
	...inputProps
}) => {
	const [localValue, setLocalValue] = useState('');

	const handleForm = (val) => {
		fieldControl.onChange(val);
		submitOnChange();
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const handleChange = useCallback(
		// eslint-disable-line react-hooks/exhaustive-deps
		debounce((value) => {
			handleForm(value);
		}, 300),
		[]
	); // eslint-disable-line react-hooks/exhaustive-deps

	if (isDirty) {
		inputProps.iconRight = (
			<Button
				onClick={() => {
					setLocalValue('');
					onReset();
				}}
			>
				<Icon extraClasses={styles.alignIcon} InlineIcon={IconClose} />
			</Button>
		);
	} else {
		inputProps.iconRight = <Icon InlineIcon={IconMagnifier} />;
	}
	return (
		<Input
			{...inputProps}
			onChange={(e) => {
				setLocalValue(e.target.value);
				handleChange(e);
			}}
			disabled={fieldControl.disabled}
			value={localValue}
		/>
	);
};

export default CrewMemberTextSearch;
